import React from 'react';
import { motion } from 'framer-motion';

const Footer = ({ onScheduleCall }) => {
  return (
    <footer className="bg-black text-white py-16 border-t border-white/10">
      <div className="container mx-auto px-6">
        <div className="grid md:grid-cols-3 gap-12 mb-12">
          <div>
            <div className="flex items-center mb-4">
              <img
                src="https://cdn.prod.website-files.com/62714322a659c56310ea38fe/627cac93404068f059e46598_Logo_White.png"
                alt="Arabica Design Studio"
                className="h-10 w-auto"
                onError={(e) => {
                  e.target.style.display = 'none';
                  e.target.nextSibling.style.display = 'flex';
                }}
              />
              <div className="hidden items-center gap-3">
                <div className="w-10 h-10 bg-white rounded-lg flex items-center justify-center">
                  <span className="text-black font-bold text-lg">A</span>
                </div>
                <span className="font-bold text-xl">Arabica Design Studio</span>
              </div>
            </div>
            <p className="text-neutral-400">
              Dedicated UI/UX and CRO design team for E-commerce, Fintech, and AI startups.
            </p>
          </div>

          <div>
            <h4 className="font-bold mb-4">Services</h4>
            <ul className="space-y-2 text-neutral-400">
              <li>Brand Identity</li>
              <li>UI/UX Design</li>
              <li>Web Design/Development</li>
              <li>CRO</li>
              <li>Product Strategy</li>
              <li>Design Systems</li>
            </ul>
          </div>

          <div>
            <h4 className="font-bold mb-4">Get in Touch</h4>
            <p className="text-neutral-400 mb-4">rakshita@arabicastudio.com</p>
            <motion.button
              className="btn-secondary font-bold"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              onClick={onScheduleCall}
            >
              Book Your Strategy Call
            </motion.button>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8">
          <p className="text-neutral-400 text-sm text-center">
            © 2025 Arabica Design Studio. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;